export function useScrollSpeed() {
  return {duration: 2000, durationSecond: 1000};
}
